import { useFormik } from "formik";
import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { jobService } from "services/job.service";
import * as Yup from "yup";

const BidNowForm = ({
  show,
  handleClose,
  selectedJobId
}) => {
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      jobId: selectedJobId,
      bidAmount: null,
      estimationDays: null,
      message: ""
    },
    enableReinitialize: true,
    validationSchema: Yup.object().shape({
      bidAmount: Yup.number().required("Please enter amount").min(1),
      estimationDays: Yup.number().required("Please enter days").min(1, 'Estimation Days must be at least 1 digit').max(999, 'Estimation Days must be at most 3 digits'),
      message: Yup.string().required("Please enter message"),
    }),
    onSubmit: async (values) => {
      try {
        setIsLoading(true);
        const response = await jobService.addBid(values);
        setTimeout(() => {
          handleClose();
          toast.success('Bid added successfully')
          navigate('/my-bids');
        }, 2000)
      } catch (err) {
        setError(err?.response?.data?.message);
      } finally {
        setTimeout(() => {
          setIsLoading(false);
        }, 2000)
      }
    },
  });

  return (
    <Modal show={show} className="modal-common" onHide={handleClose}>
      <Modal.Header closeButton>
        <p className="text-white mb-0">Bid Now</p>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={formik.handleSubmit} id="bidNowForm">
          <div className="mb-30">
            <label className="py-2">Enter Amount ($)</label>
            <br />
            <div className="form-control-bg">
            <input
              type="number"
              className="form-control rounded-3 w-100"
              name="bidAmount"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            </div>
            {formik.touched.bidAmount && formik.errors.bidAmount ? (
              <span className="text-danger">{formik.errors.bidAmount}</span>
            ) : null}
          </div>
          <div className="mb-30">
            <label className="py-2">Enter Estimated (days)</label>
            <br />
            <div className="form-control-bg">
            <input
              type="text"
              className="form-control rounded-3 w-100"
              name="estimationDays"
              value={formik.values.estimationDays}
              onChange={(e) => {
                const inputValue = e.target.value;
                const parsedValue = parseInt(inputValue);
              
                if (!isNaN(parsedValue)) {
                  if (inputValue.length > 3) {
                    formik.setFieldValue("estimationDays", parseInt(inputValue.slice(0, 3)));
                  } else {
                    formik.setFieldValue("estimationDays", parsedValue);
                  }
                } else {
                  formik.setFieldValue("estimationDays", null);
                }
              }}
              
              onBlur={formik.handleBlur}
              maxLength={3}
            />
            </div>

            {formik.touched.estimationDays && formik.errors.estimationDays ? (
              <span className="text-danger">{formik.errors.estimationDays}</span>
            ) : null}
          </div>

          <div className="mb-30">
            <label className="py-2">Message</label>
            <br />
            <div className="form-control-bg">
            <textarea
              className="form-control"
              id="exampleFormControlTextarea1"
              rows="6"
              name="message"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              maxLength={1000}
            />
            </div>
            <label className="d-block text-end pt-1 pe-1">{formik.values.message.length}/1000</label>
            {formik.touched.message && formik.errors.message ? (
              <span className="text-danger">{formik.errors.message}</span>
            ) : null}
          </div>
          {error && <div className="text-danger text-center">{error}</div>}
        </form>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="submit"
          form="bidNowForm"
          className="btn btn-primary modal-blue-btn text-capitalize w-100 text-white"
          disabled={isLoading}
        >
          {isLoading ? 'Submitting...' : 'Submit'}
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default BidNowForm;
